import Shuffle from 'shufflejs';
import openEditPanel, { refreshEditPanel } from "./editPanel.js";

const answersGrid = document.getElementById('answers-grid');
const loadingScreen = document.getElementById('answers-loading-screen');
const ageForm = document.getElementById('age-admin-form');
const genderForm = document.getElementById('gender-admin-form');
const relationForm = document.getElementById('relation-admin-form');
const questionForm = document.getElementById('question-admin-form');

const shownAnswersSpan = document.getElementById('shown-answers-span');
const allAnswersSpan = document.getElementById('all-answers-span');
const sortSelect = document.getElementById('date-sort-select');

const noAnswersDiv = document.getElementById('no-answers-admin');
const resetFiltersButton = document.getElementById('reset-filters-button');

const filterForms = [
  ageForm, genderForm, relationForm,
  questionForm
];

filterForms.forEach((form) => {
  form?.addEventListener('change', (e) => {
    filters[form.dataset.filterValue] = e.target.value;
    console.log('Updated filters:', filters);
    filterAnswers();
  });
});

resetFiltersButton.addEventListener('click', () => {
  filterForms.forEach((form) => {
    form.value = 'alle';
    filters[form.dataset.filterValue] = 'alle';
  });
  filterAnswers();
});

function showLoadingScreen() {
  loadingScreen.classList.remove('hidden');
  answersGrid.classList.add('hidden');
}

function hideLoadingScreen() {
  loadingScreen.classList.add('hidden');
  answersGrid.classList.remove('hidden');
  shuffleInstance?.update();
}

const fallbackLocations = {
  1: {
    title: 'Plek van Havenloods',
    questions: ['Sfeer', 'Havenloods', 'Deze plek is bedoelt voor...']
  },
  2: {
    title: 'Eemskanaal',
    questions: ['Sfeer', 'De kade is bedoelt voor...', 'Het water is bedoelt voor..']
  },
  3: {
    title: 'Deense Haven',
    questions: ['Sfeer', 'De kade is bedoelt voor...', 'Het water is bedoelt voor..']
  }
};

function normalizeLocationId(value) {
  const direct = Number(value);
  if (Number.isFinite(direct) && direct > 0) return direct;
  const extracted = parseInt(String(value || '').replace(/\D+/g, ''), 10);
  return Number.isFinite(extracted) && extracted > 0 ? extracted : 0;
}

function getLocationMeta(questionId) {
  const locId = normalizeLocationId(questionId);
  const points = Array.isArray(window.participationPoints) ? window.participationPoints : [];
  const point = points.find(p => Number(p.no) === locId);
  if (point) {
    return {
      title: point.title || point.name || fallbackLocations[locId]?.title || 'Locatie',
      questions: [
        point.Question1?.name,
        point.Question2?.name,
        point.Question3?.name
      ]
    };
  }
  return fallbackLocations[locId] || { title: 'Locatie', questions: [] };
}

function parseAnswerField(value) {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return value.map(String).filter(v => v.trim() !== '' && v !== '-');
  }

  const raw = String(value).trim();
  if (!raw || raw === '-') return [];

  if (raw.startsWith('[') && raw.endsWith(']')) {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.map(String).filter(v => v.trim() !== '' && v !== '-');
      }
      if (parsed != null) return [String(parsed)];
    } catch (_err) {
      // fall through
    }
  }

  let cleaned = raw;
  if (cleaned.startsWith('[') && cleaned.endsWith(']')) {
    cleaned = cleaned.slice(1, -1);
  }
  cleaned = cleaned.trim();
  if (!cleaned) return [];

  if (cleaned.includes(',')) {
    return cleaned
      .split(',')
      .map(part => part.trim().replace(/^\"+|\"+$/g, '').replace(/^'+|'+$/g, ''))
      .filter(part => part !== '' && part !== '-');
  }

  const single = cleaned.replace(/^\"+|\"+$/g, '').replace(/^'+|'+$/g, '').trim();
  return single ? [single] : [];
}

function formatAnswerField(value) {
  const list = parseAnswerField(value);
  if (!list.length) return '-';
  return list.join(', ');
}

function populateQuestionFilterOptions() {
  if (!questionForm) return;
  const current = questionForm.value || 'alle';
  const points = Array.isArray(window.participationPoints) ? window.participationPoints : [];
  const items = points.length
    ? points.map(point => ({
      id: Number(point.no || 0),
      label: `${Number(point.no || 0)}. ${point.title || point.name || 'Locatie'}`
    }))
    : Object.keys(fallbackLocations).map((key) => ({
      id: Number(key),
      label: `${key}. ${fallbackLocations[key]?.title || 'Locatie'}`
    }));

  questionForm.innerHTML = '';
  const allOption = document.createElement('option');
  allOption.value = 'alle';
  allOption.textContent = 'alle';
  questionForm.appendChild(allOption);

  items.forEach(item => {
    if (!Number.isFinite(item.id) || item.id <= 0) return;
    const option = document.createElement('option');
    option.value = String(item.id);
    option.textContent = item.label;
    questionForm.appendChild(option);
  });

  questionForm.value = current;
  if (typeof filters === 'object') {
    filters.question = questionForm.value;
  }
}

/**
 * An array of all the answers, the latest version fetched from the server
 */
let answerData = [];
let shuffleInstance = null;

function fetchAnswers(options = {}) {
  fetch(`https://publictwin.info/EngagementAppPrototypes/HavenparkGroningenPhase2PHP/Get_Gallery_Images.php`)
    .then(response => response.json())
    .then(data => {
      const newData = data;

      renderAnswers(newData);
      if (options.callback) {
        options.callback?.(data);
      }
    })
    .catch(error => {
      console.error('Error fetching answers from server:', error);
    });
}

sortSelect?.addEventListener('change', (e) => {
  currentSort = e.target.value;
  sortAnswers();
});

let currentSort = sortSelect?.value || 'new-to-old';

console.log("age form value:", ageForm.value);
const filters = {
  age: ageForm.value || "alle",
  gender: genderForm.value || "alle",
  relation: relationForm.value || "alle",
  question: questionForm.value || "alle",
};

function sortAnswers() {
  if (currentSort === 'new-to-old') {
    shuffleInstance.sort({ by: el => new Date(el.dataset.created), reverse: true });
    return;
  }
  if (currentSort === 'old-to-new') {
    shuffleInstance.sort({ by: el => new Date(el.dataset.created) });
    return;
  }
}

const standardFormAnswers = {
  gender: ["vrouw", "man", "ik zeg het liever niet"],
  relation: [
    "bewoner in de buurt van Stadshavens",
    "inwoner van Groningen"
  ],
};

function pickFirstValue(item, keys, fallback = '-') {
  for (const key of keys) {
    const value = item?.[key];
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return value;
    }
  }
  return fallback;
}

function isFilteredOut(element, filterName) {
  const currentFilter = filters[filterName];
  const value = element.dataset[filterName];
  const standardAnswers = standardFormAnswers[filterName];

  if (currentFilter === 'alle') return false;
  if (value === currentFilter) return false;

  if (currentFilter === 'anders') {
    if (!standardAnswers.includes(value)) {
      // Filtering by 'others' and value is not in standard answers
      return false;
    }
  }

  return true;
}

function filterAnswers() {
  shuffleInstance.filter(el => {
    if (isFilteredOut(el, 'age')) return false;
    if (isFilteredOut(el, "gender")) return false;
    if (isFilteredOut(el, "relation")) return false;
    if (isFilteredOut(el, "question")) return false;
    return true;
  });

  shownAnswersSpan.textContent = shuffleInstance.sortedItems.length;
  allAnswersSpan.textContent = answerData.length;

  if (shuffleInstance.sortedItems.length === 0) {
    noAnswersDiv.classList.remove('hidden');
  } else {
    noAnswersDiv.classList.add('hidden');
  }
}

function renderAnswers(newData) {
  answerData = newData;
  // console.log('Rendering admin panel with data:', answerData);

  // Clear grid
  answersGrid.innerHTML = '';
  hideLoadingScreen();

  // Create items
  answerData.forEach(item => {
    const div = document.createElement('div');

    div.addEventListener('click', () => {
      openEditPanel([item], () => {
        fetchAnswers({
          callback: (newData) => {
            const updated = newData.find(entry => String(entry.id) === String(item.id));
            if (updated) {
              refreshEditPanel([updated]);
            }
          }
        });
      });
    });

    div.classList.add('answer-item');

    const ageValue = pickFirstValue(item, ['age_group', 'ageGroup', 'age'], '-');
    const genderValue = pickFirstValue(item, ['gender', 'genderGroup'], '-');
    const relationValue = pickFirstValue(item, ['relation_to_place', 'relationToPlace', 'relation'], '-');

    div.dataset.created = item.created;
    div.dataset.age = ageValue;
    div.dataset.gender = genderValue;
    div.dataset.relation = relationValue;
    div.dataset.question = item.question_id ?? '0';

    const userDataDiv = document.createElement('div');

    userDataDiv.classList.add("user-data");

    userDataDiv.innerHTML = `<img class="CheckboxMainMenuIcon"
      src="https://publictwin.info/digital_maquette/content/Urban_Future/Icons/PersonIcon.svg" />`;

    const userLabel = pickFirstValue(item, ['user_identifier', 'userIdentifier', 'user_IP', 'userIp'], '-');
    const gender = genderValue === "ik zeg het liever niet" ?
      "niet vermeld" : genderValue;
    const relationToPlace = relationValue.trim() === "bewoner in de buurt van Stadshavens" ?
      "bewoner Stadshavens" : relationValue.trim();

    userDataDiv.innerHTML += `${userLabel} — ${gender} (${ageValue}), ${relationToPlace}`;

    const answerDataDiv = document.createElement('div');
    const locationMeta = getLocationMeta(item.question_id);
    const questionLabels = locationMeta.questions?.length
      ? locationMeta.questions
      : ['Vraag 1', 'Vraag 2', 'Vraag 3'];

    answerDataDiv.classList.add("answer-data");
    questionLabels.forEach((label, index) => {
      if (!label) return;
      const answerValue = [
        item.question1_answers,
        item.question2_answers,
        item.question3_answers
      ][index];
      answerDataDiv.innerHTML += `<div><b>${label}:</b> ${formatAnswerField(answerValue)}</div>`;
    });

    const infoDiv = document.createElement('div');

    infoDiv.classList.add("answer-info", "flex-row");
    infoDiv.innerHTML = `<div>Datum: <b>${item.created}</b></div>`;
    div.appendChild(userDataDiv);
    div.appendChild(answerDataDiv);
    div.appendChild(infoDiv);

    answersGrid.appendChild(div);

    item.domElement = div; // Store reference for later use
  });

  // Initialize Shuffle if not already
  if (!shuffleInstance) {
    shuffleInstance = new Shuffle(answersGrid, {
      itemSelector: '.answer-item',
      sizer: '.answer-sizer',
    });
  } else {
    shuffleInstance.resetItems();
  }

  // Initial filtering and sorting
  filterAnswers();
  sortAnswers();
}

export default function openAdminPanel() {
  showLoadingScreen();
  populateQuestionFilterOptions();
  fetchAnswers();
}
